export default "__VITE_ASSET__6e19596a__"